module.exports = __webpack_public_path__ + "img/avatar-7.13de9fc2.jpg";